import React, { useRef, useState } from "react";
import { Plus } from "lucide-react";
import CodeEditor from "../../../../../components/elements/CodeEditor";

export default function PlaceholderTemplateEditor({
                                                      language,
                                                      value,
                                                      onChange,
                                                      onInsertPlaceholder,
                                                  }) {

    const editorRef = useRef(null);

    const [key, setKey] = useState("");

    const insertPlaceholder = () => {

        const placeholder = key.trim().toUpperCase();

        if (!placeholder)
            return;

        const token = `[[${placeholder}]]`;

        const editor = editorRef.current?.view;

        if (!editor) {

            onChange((value || "") + token);

        } else {

            const selection = editor.state.selection.main;

            editor.dispatch({

                changes: {
                    from: selection.from,
                    to: selection.to,
                    insert: token,
                }

            });

            onChange(editor.state.doc.toString());

        }

        onInsertPlaceholder(placeholder);

        setKey("");

    };

    return (

        <div className="space-y-3">

            <CodeEditor
                ref={editorRef}
                language={language}
                value={value}
                onChange={onChange}
                height={320}
            />

            <div className="flex gap-2">

                <input
                    className="flex-1 border rounded-lg p-2"
                    placeholder="BODY"
                    value={key}
                    onChange={(e) => setKey(e.target.value)}
                />

                <button
                    type="button"
                    onClick={insertPlaceholder}
                    className="px-4 rounded-lg bg-blue-600 text-white inline-flex items-center gap-2"
                >
                    <Plus size={16}/>
                    Insert Placeholder
                </button>

            </div>

            <p className="text-xs text-gray-500">

                Placeholderها به صورت
                <span className="font-mono"> [[BODY]] </span>
                داخل کد قرار می‌گیرند.

            </p>

        </div>

    );

}